import React, { useMemo } from "react";
import { Header, Segment, Message } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import FrontPageCounters from '../components/observation/ObservationCounters'
import { useCategoryList } from "../store/selectors/categorySelectors";
import { isLoading, isLoadErrored, isLoaded } from "../../../sg-core";
import FormCategoryMenu from "../components/formType/FormCategoryMenu";
import { TFunction } from "i18next";
import { PageTemplate } from "../components/PageTemplate/PageTemplate";

const getTextProps = (t: TFunction) => ({
    headerText: t("Havaintosovellus"),
    createNewObservationText: t("Tee uusi havainto"),
    loadError: t("Latauksessa tapahtui virhe!")
});


interface IFrontPageProps extends ReturnType<typeof getTextProps> { };

const FrontPage: React.FC<IFrontPageProps> = ({ headerText, createNewObservationText, loadError }) => {

    const categories = useCategoryList();

    if (isLoading(categories)) {
        return <Segment loading placeholder basic />
    }

    return (
        <PageTemplate>
            <Header size="large" as="h1">{headerText}  </Header>

            <FrontPageCounters />

            <Header as="h3" textAlign="center"> {createNewObservationText} </Header>

            {isLoadErrored(categories) ? (
                <Message content={loadError} negative />
            ) : isLoaded(categories) ? (
                <FormCategoryMenu categories={categories.data} />
            ) : <Segment loading placeholder basic />
            }
        </PageTemplate>
    );
};

const MemoizedFrontPage = React.memo(FrontPage);

const FrontPageContainer: React.FC = () => {
    const { t } = useTranslation();
    const textProps = useMemo(() => getTextProps(t), [t]);
    return <MemoizedFrontPage {...textProps} />;
};

export default FrontPageContainer;
